import {skipToken} from '@reduxjs/toolkit/query';
import {isFeatureEnabled} from 'feature-flags';
import {MenuBadge} from 'platform/components';

import {isNotNilOrEmpty, isPositive} from 'ramda-adjunct';

import {useListRecordAuditsByRecordQuery} from '@dms/api/core';
import {featureFlags} from '@dms/feature-flags';

interface UseRecordAuditsBadgeProps {
  /** Resource/record pair the audits are listed for (mirrors the API contract). */
  resourceId: string;
  /** Pass an empty string to suppress the query (e.g. while the host card is collapsed). */
  recordId: string;
}

interface UseRecordAuditsBadgeReturn {
  badgeSettings: MenuBadge | undefined;
}

/**
 * Tab badge signalling that a record has audits: neutral badge with the audit count,
 * hidden when the record has none.
 */
export function useRecordAuditsBadge(props: UseRecordAuditsBadgeProps): UseRecordAuditsBadgeReturn {
  const auditsQuery = useListRecordAuditsByRecordQuery(
    isFeatureEnabled(featureFlags.CORE_CHECKLIST_AUDITS) && isNotNilOrEmpty(props.recordId)
      ? {resourceId: props.resourceId, recordId: props.recordId}
      : skipToken
  );

  const auditCount = (auditsQuery.data ?? []).length;

  return {
    badgeSettings: isPositive(auditCount) ? {colorScheme: 'neutral', value: auditCount} : undefined,
  };
}
